<template>
    <div>
        <div class="ap-workspace-head">
            <div class="ap-workspace-label">
                <div class="ap-workspace-label-name">
                    Конфигурация приложения
                </div>
<!--                <div class="ap-workspace-label-btn">-->
<!--                    <SVGPlus/>-->
<!--                </div>-->
            </div>
<!--            <div class="ap-workspace-label-btn ap-add-left-margin">-->
<!--                <label class="ap-search">-->
<!--                    <input type="text" class="ap-search-input" placeholder="Найти пользователя" v-model="mask">-->
<!--                </label>-->
<!--            </div>-->
        </div>
        <vue-custom-scrollbar>
            <div class="ap-workspace-table-container workspace-admin-scroll-part">
                <table class="result-table">
                    <thead>
                    <tr class="head-tr">
                        <th>№</th>
                        <th>Название переменной</th>
                        <th>Значение</th>
                        <th>Значение по умолчанию</th>
                        <th class="field-edit">Опции</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="body-tr row" v-for="(value, index) in config">
                        <!--                        <td>-->
                        <!--                            <span class="table-data-central">{{value.id}}</span>-->
                        <!--                        </td>-->
                        <td>
                            <span class="table-data">{{index+1}}</span>
                        </td>
                        <td>
                            <span class="table-data">{{value.name}}</span>
                        </td>
                        <td>
                            <span class="table-data">{{value.value}}</span>
                        </td>
                        <td>
                            <span class="table-data">{{value.default}}</span>
                        </td>
                        <td>
                            <div class="edit-button-group">
                                <div class="table-svg-button" v-on:click="editRow(value)">
                                    <SVGAdminEditRow/>
                                </div>
                                <div class="table-svg-button" v-on:click="confirm(value)">
                                    <SVGPhotoRotateLeft/>
                                </div>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div v-if="waitingResponseToConfigRequest" class="ap-loader-grid">
                    <SpinnerTwo/>
                    <div class="ap-loader-text">
                        Идет загрузка переменных ...
                    </div>
                </div>
            </div>
        </vue-custom-scrollbar>
    </div>
</template>

<script>
    import SVGAdminEditRow from "../../SVG/SVGAdminEditRow.vue";
    import {urlForStaticVue} from "../../common";
    import vueCustomScrollbar from 'vue-custom-scrollbar';
    import SpinnerTwo from "../../SpinnerTwo";
    import ModalChangeVariableValue from "../../Modal/AdminPage/ModalChangeVariableValue";
    import SVGPhotoRotateLeft from "../../SVG/SVGPhotoRotateLeft";
    import ModalConfirmation from "../../Modal/ModalConfirmation";

    export default {
        name: "AdminConfig",
        mixins: [urlForStaticVue],
        components: {
            SVGPhotoRotateLeft,
            SpinnerTwo,
            SVGAdminEditRow,
            vueCustomScrollbar
        },
        computed: {
            config(){
                return this.$store.getters["adminPanel/config/SELF"];
            },
            waitingResponseToConfigRequest(){
                return this.$store.state.adminPanel.config.waitingResponseToConfigRequest;
            }
        },
        methods: {
            editRow(value) {
                console.log(value);
                this.$modal.show(ModalChangeVariableValue, {
                    dataConfig: {
                        SubmitButtonText: 'Задать значение',
                        value: value
                    },
                }, {
                    height: 'auto',
                    pivotY: 0.2,
                    width: 450,
                    draggable: true,
                });
            },
            confirm(value) {
                const title = 'Сбросить параметр "' + value.name + '"?'
                const text = 'Подтвердите действие, чтобы сбросить параметр до значения по умолчанию, вы уверены, что хотите продолжить?';
                this.$modal.show(ModalConfirmation, {title, text, alright: this.resetRow({
                        name: value.name,
                        value: value.default,
                        default: value.default
                    })}, {
                    name: 'confirmationModal',
                    height: 'auto',
                    pivotY: 0.2,
                    width: 460,
                    draggable: true,
                });
            },
            resetRow(value) {
                return () => {this.$store.dispatch('adminPanel/config/RESET_CONFIG', value)};
            },
        },
        async mounted() {
            await this.$store.dispatch('adminPanel/config/GET_CONFIG');
        }
    }
</script>

<style scoped>

</style>
